import instance from "../config";

const inventarioVR = async (params) => {
  try {
    const response = await instance.get("/api/inventarioVR", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

const inventarioStock = async (params) => {
  try {
    const response = await instance.get("/api/inventarioStock", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

const inventarioCM = async (params) => {
  try {
    const response = await instance.get("/api/inventarioCM", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

const inventarioNomina = async (params)=>{
  try {
    const response = await instance.get("/api/inventarioNomina", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}

const inventarioAlquiler = async (params) => {
  try {
    const response = await instance.get("/api/inventarioAlquiler", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export { inventarioVR, inventarioStock, inventarioCM, inventarioNomina, inventarioAlquiler };
